import utils from 'blue-utils';
import publicConfig from '$config';
import router from '@router';

//环境
import env from './env';

//环境域名路径
const path = (() => {
  let path = '';
  if (env.dev) {
    path = 'https://pc.jiaxiao.dtb315.cn';
  } else if (env.beta) {
    path = 'https://beta.jiaxiao.dtb315.cn';
  } else if (env.test) {
    path = 'https://w1.jiaxiao.dtb315.cn';
  } else {
    path = 'https://jiaxiao.dtb315.com';
  }
  return path;
})();

//环境域名路径
const dtbPath = (() => {
  let path = '';
  if (env.dev) {
    path = 'https://pc.dtb315.cn';
  } else if (env.beta) {
    path = 'https://beta.dtb315.cn';
  } else if (env.test) {
    path = 'https://w1.jiaxiao.dtb315.cn';
  } else {
    path = 'https://www.dtb315.com';
  }
  return path;
})();

//静态资源路径
const staticPath = `${path}/static`;

//登录path
const loginPath = (() => {
  return `${dtbPath}/home/common/index`;
})();

//绑定手机
const bindPhonePath = (() => {
  return `${dtbPath}/common/wechatlogin`;
})();

//合并公共的配置
const config = utils.extend(publicConfig, {
  user: {
    url: '/api/Apipublic'
  },
  view: {
    title: "慧联天下·上大夫说",
    tabBar: 'home',
    keepAlive: {
      exclude: [
        
      ]
    }
  },
  env,
  path: {
    base: location.origin,
    static: staticPath,
    login: loginPath,
    bindPhone: bindPhonePath
  },
  //微信相关
  weChat: {
    getConfig: {
      type: 'get',
      url: '/api/Index/wechat',
      data: {}
    }
  },
  //分享的默认内容，在获取用户信息时会被替换成后台传的
  share: {
    origin: `${dtbPath}/common/autoreg`,
    title: "生活导航·智慧导航",
    deps: "--- 来自慧联天下综合服务平台。",
    imgUrl: `${staticPath}/img/public/share/default-share-img.png`
  }
});
export default config;
